export function initStatementIconNumeration() {
  document
    .querySelectorAll('.Statement-icon-numeration')
    .forEach(async (container) => {
      const { tns } = await import('tiny-slider/src/tiny-slider')
      const isDesktopSlider = container.classList.contains(
        'Statement-icon-numeration--slider',
      )
      const swiperEl = container.querySelector('.swiper')!
      const itemsEl = container.querySelector(
        '.Statement-icon-numeration__items',
      )

      if (!isDesktopSlider && itemsEl) {
        const updateFlexed = () => {
          if (window.innerWidth > 767) {
            itemsEl.classList.add('flexed')
          } else {
            itemsEl.classList.remove('flexed')
          }
        }
        updateFlexed()
        window.addEventListener('resize', updateFlexed)
      }

      const prevButton = container.querySelector(
        '.Statement-icon-numeration__prev',
      ) as HTMLElement
      const nextButton = container.querySelector(
        '.Statement-icon-numeration__next',
      ) as HTMLElement

      tns({
        container: swiperEl,
        preventScrollOnTouch: 'auto',
        swipeAngle: 30,
        loop: false,
        slideBy: 'page',
        controls: true,
        nav: true,
        navPosition: 'bottom',
        prevButton,
        nextButton,
        disable: false,
        ...(isDesktopSlider
          ? {
              items: 1,
              center: true,
              gutter: 10,
              responsive: {
                768: {
                  items: 2,
                  center: false,
                  gutter: 20,
                },
                992: {
                  items: 3,
                },
                1200: {
                  items: 4,
                },
              },
            }
          : {
              items: 1,
              center: true,
              autoWidth: true,
              // @ts-ignore
              viewportMax: true,
              fixedWidthViewportWidth: 100,
              gutter: 10,
              slideBy: 'page',
              responsive: {
                768: {
                  disable: true,
                  center: false,
                },
              },
            }),
      })
    })
}
